import baysportLogo from "../assets/logo.png";
import L from "../constants/baysportLabels";
import { mediaUrl } from "./clientHeroTheme";

const DEFAULT_SPLASH_BG = {
  background:
    "linear-gradient(160deg, #8b5cf6 0%, #a78bfa 22%, #c4b5fd 48%, #ddd6fe 78%, #ede9fe 100%)",
};

function personalizedSplashBackground(color) {
  const c = String(color || "").trim();
  if (!c || !/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(c)) {
    return {
      background: "linear-gradient(180deg, #141824 0%, #06080f 100%)",
    };
  }
  return {
    background: `linear-gradient(165deg, color-mix(in srgb, ${c} 34%, #12151f) 0%, #0a0c12 46%, #06080f 100%)`,
  };
}

/**
 * Splash PWA: на «Стартовом» — BaySport, на «Расширенном»+ — логотип и цвета клуба.
 */
export function resolveSplashBranding({ tenant, features } = {}) {
  const clubName = tenant?.name?.trim() || "";
  const personalized = Boolean(features?.splash_branding);

  if (!personalized) {
    return {
      personalized: false,
      logoSrc: baysportLogo,
      brandTitle: L.productName,
      tagline: clubName || "Ваш спортивный клуб",
      splashBgStyle: DEFAULT_SPLASH_BG,
    };
  }

  return {
    personalized: true,
    logoSrc: mediaUrl(tenant?.logo_url) || baysportLogo,
    brandTitle: clubName || L.productName,
    tagline: clubName ? "Добро пожаловать" : "Ваш спортивный клуб",
    splashBgStyle: personalizedSplashBackground(tenant?.portal_accent_color),
  };
}

export function useSplashBrandingFromAuth(authState) {
  const tenant = authState?.tenant;
  const features = authState?.entitlements?.features;
  return resolveSplashBranding({ tenant, features });
}

/**
 * Иконка и название PWA: логотип клуба + цвет акцента.
 * Достаточно загрузить аватар в настройках портала.
 */
export function resolvePwaBranding({ tenant, features } = {}) {
  const clubName = tenant?.name?.trim() || "";
  const rawLogo = tenant?.logo_url?.trim() || "";
  const logoSrc = rawLogo ? mediaUrl(rawLogo) : null;
  const themeColor = tenant?.portal_accent_color || null;
  const splashBranding = Boolean(features?.splash_branding);

  const personalized = Boolean(logoSrc) || (splashBranding && clubName);

  return {
    personalized,
    clubName,
    logoSrc: logoSrc || baysportLogo,
    themeColor,
  };
}
